<template>
  <div>
    <autoLogout />
    <loader :loader="sending" />
    <div class="wrapper-content">
      <encabezado :elementos="encabezado" v-if="showAction(1)" />
      <v-card v-if="showAction(1)">
        <v-card-text>
          <v-row align="baseline" justify="center" class="pb-4">
            <v-col
              ><v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field
            ></v-col>
            <v-col
              cols="12"
              md="4"
              xl="2"
              sm="12"
              @click="changeAction(2)"
              v-if="$utilFront.withPermission($prm.MODULE_CONF)"
            >
              <btn-accion :elements="btnAdd" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-data-table
          :headers="headers"
          :items="list"
          :search="search"
          :items-per-page="10"
          :footer-props="{
            'items-per-page-text': 'Elementos por página',
            'items-per-page-all-text': 'Todo',
          }"
          no-results-text="Sin resultados coincidentes con el búsqueda"
          loading-text="Cargando..."
          no-data-text="Sin resultados disponibles"
          class="mx-5"
          dense
          fixed-header
          height="auto"
        >
          <template v-slot:[`item.status`]="{ item }">
            <v-btn
              icon
              @click.native.prevent.stop.capture="editarStatus(item)"
              v-if="$utilFront.withPermission($prm.MODULE_CONF)"
            >
              <v-switch v-model="item.status" color="success"></v-switch>
            </v-btn>
            <span
              v-else
              :class="{
                'error--text': !item.status,
                'success--text': item.status,
              }"
            >
              {{ item.status ? "Activo" : "Inactivo" }}
            </span>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip top v-if="$utilFront.withPermission($prm.MODULE_CONF)">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon @click="checkCategory(item)">
                  <v-icon color="blue" v-bind="attrs" v-on="on">
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </template>
              <span>Editar información</span>
            </v-tooltip>
            <span v-else> - - - </span>
          </template>
        </v-data-table>
      </v-card>
      <encabezado
        :elementos="encabezado"
        v-if="showAction(2) || showAction(3)"
      />
      <v-card v-if="showAction(2) || showAction(3)">
        <v-card-title> </v-card-title>
        <validation-observer ref="form" v-slot="{ invalid }">
          <v-form @submit.prevent="doAction">
            <div class="container">
              <v-row>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Nombre de categoría"
                    rules="required|max:150"
                  >
                    <v-text-field
                      v-model="dataModal.name"
                      :counter="150"
                      :error-messages="errors"
                      label="Nombre de Categoría"
                      required
                      autocomplete="off"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Método de obtención"
                    rules="max:150"
                  >
                    <v-text-field
                      v-model="dataModal.method"
                      :counter="150"
                      :error-messages="errors"
                      label="Método de obtención"
                      autocomplete="off"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Muestra"
                    rules="max:150"
                  >
                    <v-text-field
                      v-model="dataModal.sample"
                      :counter="150"
                      :error-messages="errors"
                      label="Muestra"
                      autocomplete="off"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Perfil de estudio"
                    rules="required"
                  >
                    <v-autocomplete
                      v-if="showAction(2)"
                      v-model="dataModal.studyModality"
                      label="Perfil de estudio"
                      :items="listStudyModality"
                      :item-text="listStudyModality.text"
                      :item-value="listStudyModality.value"
                      :error-messages="errors"
                    >
                    </v-autocomplete>
                    <v-autocomplete
                      v-if="showAction(3)"
                      v-model="dataModal.studyModality.idStudyModality"
                      label="Perfil de estudio"
                      :items="listStudyModality"
                      :item-text="listStudyModality.text"
                      :item-value="listStudyModality.value"
                      :error-messages="errors"
                    >
                    </v-autocomplete>
                  </validation-provider>
                </v-col>
              </v-row>
            </div>
            <div class="d-flex justify-center">
              <v-col class="d-flex justify-space-around">
                <div v-on:click="changeAction(1)">
                  <btn-accion :elements="btnCancell" />
                </div>
                <v-btn
                  type="submit"
                  :disabled="sending || invalid"
                  color="success"
                >
                  <v-icon left>{{ iconoAdd }}</v-icon>
                  {{ textoAdd }}
                </v-btn>
              </v-col>
            </div>
          </v-form>
        </validation-observer>
      </v-card>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import Datatable from "../../components/Datatable.vue";
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "../../components/Sidebar";
import BtnAccion from "../../components/btnAccion.vue";
import AutoLogout from "../../components/AutoLogout.vue";
import { CategoryRequest, StudyModalityRequest } from "@/core/request";
import { required, max } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import { mapActions } from "vuex";
import ExportImportBtn from "../../components/ExportImportBtn.vue";
import Loader from "../../components/Loader.vue";
setInteractionMode("eager");
extend("required", {
  ...required,
  message: "{_field_} no puede quedar vacío",
});
extend("max", {
  ...max,
  message: "{_field_} no debe ser mayor de {length} caracteres",
});

export default {
  name: "Perfiles",
  components: {
    Sidebar,
    Encabezado,
    ValidationObserver,
    ValidationProvider,
    Datatable,
    BtnAccion,
    AutoLogout,
    ExportImportBtn,
    Loader,
    CategoryRequest,
  },
  data() {
    return {
      importDialog: false,
      dialog: false,
      search: "",
      dataModal: {},
      action: 1,
      encabezado: {
        icono: "mdi-menu",
        texto: "Categorías",
      },
      list: [],
      listStudyModality: [],
      sending: false,
      dialogs: {
        title: "¿Desea modificar el estatus?",
        text:
          "La categoría será habilitado / inhabilitado de inmediato y podría afectar a los registros que dependan de él",
      },
      headers: [
        { text: "ID Categoría", value: "idCategory" },
        { text: "Nombre", value: "name" },
        { text: "Perfil de Estudio", value: "studyModality.name" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      btnAdd: {
        icon: "mdi-plus",
        text: "Agregar Categoría",
        tooltip: "Agregar Categoría",
      },
      btnCancell: {
        icon: "mdi-close",
        text: "Cancelar registro",
        tooltip: "Cancelar registro",
        color: "error",
      },
      iconoAdd: "mdi-plus",
      textoAdd: "Registrar categoría",
      service: CategoryRequest,
      updateModal: false,
      results: {},
      fileXls: null,
    };
  },
  created() {},
  mounted() {
    this.validBrowserTab();
    this.listAll();
    this.listStudyModalities();
  },
  methods: {
    ...mapActions(["validTab", "unauthorized"]),
    validBrowserTab() {
      this.validTab();
    },
    catchError: (e) => {
      //console.log(e);
      this.$utilFront.notifications("Ha ocurrido un error interno", "ERROR");
    },
    showAction(action) {
      return this.action == action;
    },
    editarStatus(item) {
      this.dialog = true;
      this.dataModal = Object.assign(this.dataModal, item);
    },
    changeAction(action) {
      if (action == 1) {
        this.$refs.form.reset();
        this.dataModal = {};
      } else if (action == 2) {
        this.dataModal = {};
      } else if (action == 3) {
      }
      this.action = action;
      this.checkEncabezado();
    },
    checkEncabezado() {
      switch (this.action) {
        case 1:
          this.encabezado = {
            icono: "mdi-menu",
            texto: "Categorías",
          };
          this.dialogs = {
            title: "¿Desea modificar el estatus?",
            text:
              "La categoría será habilitado / inhabilitado de inmediato y podría afectar a los registros que dependan de él",
          };
          break;
        case 2:
          this.encabezado = {
            icono: "mdi-menu",
            texto: "Registrar categoría",
          };
          this.dialogs = {
            title: "¿Desea registrar éste categoría?",
            text:
              "La categoría será registrado de inmediato y estará disponible en el sistema",
          };
          this.iconoAdd = "mdi-plus";
          this.textoAdd = "Registrar categoría";
          this.btnCancell = {
            icon: "mdi-close",
            text: "Cancelar registro",
            tooltip: "Cancelar registro",
            color: "error",
          };
          break;
        case 3:
          this.encabezado = {
            icono: "mdi-menu",
            texto: "Editar categoría",
          };
          this.dialogs = {
            title: "¿Desea modificar éste categoría?",
            text:
              "La categoría será modificado de inmediato y podría afectar a los registros que dependan de él",
          };
          this.iconoAdd = "mdi-reload";
          this.textoAdd = "Editar categoría";
          this.btnCancell = {
            icon: "mdi-close",
            text: "Cancelar Modificación",
            tooltip: "Cancelar Modificación",
            color: "error",
          };
          break;
        default:
          this.encabezado = {
            icono: "mdi-menu",
            texto: "Categorías",
          };
          break;
      }
    },
    doAction() {
      //this.sending = !this.sending;
      if (this.$refs.form.validate()) {
        // this.dialog = true;
        if (this.action == 2) {
          this.add();
        } else if (this.action == 3) {
          this.update();
        }
      }
    },
    sendData() {
      this.sending = !this.sending;
    },

    listStudyModalities() {
      StudyModalityRequest.allStudyModality().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.listStudyModality = res.data.data.map((modality) => {
            return {
              value: modality.idStudyModality,
              text: modality.name,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },

    listAll() {
      this.service.listAllCategory().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.list = res.data.data.map((cat) => {
            return {
              idCategory: cat.idCategory,
              name: cat.name,
              sample: cat.sample,
              method: cat.method,
              studyModality: cat.studyModality || "--- Sin información ---",
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    add() {
      if (!this.sending) {
        this.sending = true;
        let postData = {
          name: this.dataModal.name.trim(),
          method: this.dataModal.method,
          sample: this.dataModal.sample,
          studyModality: {
            idStudyModality: this.dataModal.studyModality,
          },
        };
        CategoryRequest.addCategory(postData)
          .then((res) => {
            this.listAll();
            if (res.data.code === 200) {
              this.$utilFront.notifications(
                "Categoría registrada correctamente",
                "SUCCESS"
              );
              this.changeAction(1);
            } else if (res.data.code === 401) {
              this.unauthorized();
            } else {
              this.$utilFront.notifications(res.data.data, "ERROR");
            }
          })
          .finally(() => {
            this.sending = false;
          });
      }
    },
    update() {
      if (!this.sending) {
        this.sending = true;
        let postData = {
          idCategory: this.dataModal.idCategory,
          name: this.dataModal.name.trim(),
          method: this.dataModal.method.trim(),
          sample: this.dataModal.sample.trim(),
          studyModality: {
            idStudyModality: this.dataModal.studyModality.idStudyModality,
          },
        };
        CategoryRequest.updateCategory(postData)
          .then((res) => {
            this.listAll();
            if (res.data.code === 200) {
              this.$utilFront.notifications(
                "Categoría modificada correctamente",
                "SUCCESS"
              );
              this.changeAction(1);
            } else if (res.data.code === 401) {
              this.unauthorized();
            } else {
              this.$utilFront.notifications(res.data.data, "ERROR");
            }
          })
          .finally(() => {
            this.sending = false;
          });
      }
    },

    checkCategory(item) {
      this.dataModal = Object.assign(this.dataModal, item);
      this.changeAction(3);
    },
  },
  computed: {},
};
</script>
